var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[(_vm.isLoaded)?_c('img',{attrs:{"src":_vm.url,"alt":"banner"}}):_c('vue-content-loading',{attrs:{"width":310,"height":65}},[_c('rect',{attrs:{"cx":"30","cy":"30","width":"310","r":"30","height":"65","x":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }